import ItemSidebar from 'components/CalendarItem/ItemSidebar'
import { useAuth } from 'context/AuthContext'
import { useCallback, useEffect, useState } from 'react'
import { AttendeeItem } from 'types/attendee'
import { BookingForm, BookingFormExtra } from 'types/booking'
import { CalendarSlotItem } from 'types/calendar'
import { TenantIntegration } from 'types/tenant-integration'

export default function ClientSidebar() {
    const { CreateClientModal } = useAuth() // Always call useAuth unconditionally
    const attributes = CreateClientModal?.attributes || {}
    const setAttributes = CreateClientModal?.setAttributes || (() => {})

    // Declare useState hooks unconditionally
    const [sidebar_data, setSideBarData] = useState<CalendarSlotItem>(
        {} as CalendarSlotItem
    )
    const [attendees, setAttendees] = useState<AttendeeItem[]>([])

    // Helper function to check for changes
    const hasChanged = useCallback((prev: any, next: any) => {
        return JSON.stringify(prev) !== JSON.stringify(next)
    }, [])

    useEffect(() => {
        if (hasChanged(attendees, attributes?.attendees)) {
            setAttributes({
                ...attributes,
                attendees,
            })
        }
    }, [attendees, attributes?.attendees, setAttributes])

    useEffect(() => {
        if (hasChanged(sidebar_data, attributes?.data)) {
            setAttributes({
                ...attributes,
                data: sidebar_data,
            })
        }
    }, [sidebar_data, attributes?.data, setAttributes])

    return (
        <>
            {attributes && (
                <ItemSidebar
                    show={attributes?.show as boolean}
                    toggleShow={(show: boolean) => {
                        setAttributes({
                            ...attributes,
                            show,
                        })
                    }}
                    anim_css={
                        attributes?.anim_css
                            ? (attributes?.anim_css as string[])
                            : ['bg-opacity-0', 'translate-x-full']
                    }
                    setAnimCss={(anim_css: string[]) => {
                        setAttributes({
                            ...attributes,
                            anim_css,
                        })
                    }}
                    data={attributes?.data as CalendarSlotItem}
                    setData={setSideBarData}
                    staff={attributes?.staff as Record<string, string>}
                    setStaff={(staff: Record<string, string>) => {
                        setAttributes({
                            ...attributes,
                            staff,
                        })
                    }}
                    payment_integrations={
                        (attributes?.payment_integrations as TenantIntegration[]) ||
                        []
                    }
                    attendees={
                        (attributes?.attendees as AttendeeItem[]) || []
                    }
                    setAttendees={setAttendees}
                    booking_form={
                        (attributes?.booking_form as BookingForm &
                            BookingFormExtra) || {}
                    }
                    setBookingForm={(
                        booking_form: BookingForm & BookingFormExtra
                    ) => {
                        setAttributes({
                            ...attributes,
                            booking_form,
                        })
                    }}
                    is_from_client_modal={true}
                    main_attendee_idx={
                        attributes?.main_attendee_idx as number
                    }
                    onUpdate={attributes?.onUpdate as () => void}
                />
            )}
        </>
    )
}
